import {Course} from '@jobseeker/common-core/types';
import CourseDetailComponent from '@jobseeker/feature-course/components/CourseDetail';

const CourseDetail = (
  props: Course & {
    handleEnquiryInLoggedOutState: () => void;
    forUnpublishedCourse?: boolean;
  }
) => {
  return <CourseDetailComponent {...props} />;
};

export default CourseDetail;
